export default __webpack_public_path__ + "static/media/opinion2.03796610.jpg";